const isNotNullAndUndefined = (value) => {
	return value !== null && value !== undefined;
};

const isValidMonth = (month) => {
	if (month === null || month === undefined) return false;
	const value = typeof month === 'string' ? parseInt(month, 10) : month;
	return value >= 0 && value <= 11;
};

const isValidYear = (year) => {
	if (year === null || year === undefined) return false;
	const value = typeof year === 'string' ? parseInt(year, 10) : year;
	return Number.isInteger(value) && value >= 1 && value <= 9999;
};

export { isNotNullAndUndefined, isValidMonth, isValidYear };
